module.exports = "/_next/static/media/37c0d655230eebd7fdd11d5fcd10c7b3.svg";